import React, { useState, useEffect } from "react";
import { Input, Button, InputNumber, TimePicker } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment-timezone";

export interface VolunteerOptionInput {
  name?: string;
  max?: number;
  startTime?: string;
  endTime?: string;
}

interface VolunteerOptionProps {
  value?: VolunteerOptionInput;
  canDel?: boolean;
  onChange?: (value: VolunteerOptionInput) => void;
  onDel?: () => void;
}

export const VolunteerOption = ({ value = {}, canDel = false, onDel, onChange }: VolunteerOptionProps) => {
  const [model, setModel] = useState<VolunteerOptionInput>(value);

  useEffect(() => {
    setModel(value);
  }, [value]);

  return (
    <Input.Group compact>
      <Input
        style={{ width: canDel ? "calc(100% - 352px)" : "calc(100% - 320px)" }}
        placeholder="Name"
        value={model.name}
        onChange={(e) => {
          onChange && onChange({ ...model, name: e.target.value });
        }}
      />
      <TimePicker
        style={{ width: 120 }}
        placeholder="Start Time"
        showNow={false}
        value={model.startTime ? moment(model.startTime, "HH:mm") : null}
        minuteStep={5}
        format="HH:mm"
        onChange={(time: moment) => {
          onChange && onChange({ ...model, startTime: time?.format("HH:mm") });
        }}
      />
      <TimePicker
        style={{ width: 120 }}
        placeholder="End Time"
        showNow={false}
        value={model.endTime ? moment(model.endTime, "HH:mm") : null}
        minuteStep={5}
        format="HH:mm"
        onChange={(time: moment) => {
          onChange && onChange({ ...model, endTime: time?.format("HH:mm") });
        }}
      />
      <InputNumber
        style={{ width: 80 }}
        value={model.max}
        placeholder="max"
        min={0}
        onChange={(max) => {
          onChange && onChange({ ...model, max });
        }}
      />
      {canDel && <Button style={{ width: 32 }} icon={<DeleteOutlined />} onClick={() => onDel && onDel()}></Button>}
    </Input.Group>
  );
};
